export function randomBase36(length = 8) {
  const len = Math.max(1, Number(length) || 8);
  return Math.random().toString(36).slice(2, 2 + len);
}

export function createRandomId(
  prefix = "id",
  { randLen = 10, includeTime = true } = {},
) {
  const rand = randomBase36(randLen);
  const time = includeTime ? `-${Date.now().toString(36)}` : "";
  return `${prefix}-${rand}${time}`;
}
